import { Controller } from "@hotwired/stimulus";

// Modal Controller
export default class extends Controller {
  static targets = ["container", "content"];

  open(event) {
    this.stopPropagation(event);
    
    const url = event.currentTarget.dataset.modalUrl;
    fetch(url)
      .then(response => response.text())
      .then(html => this.contentTarget.innerHTML = html);

    this.containerTarget.classList.remove("hidden");
    this.containerTarget.classList.add("flex");
  }

  close() {
    this.containerTarget.classList.remove("flex");
    this.containerTarget.classList.add("hidden");
  }

  closeOutside(event) {
    if (event.target === this.containerTarget) {
      this.close();
    }
  }

  stopPropagation(event) {
    event.stopPropagation();
  }
}
